import { render, staticRenderFns } from "./MessageMenu.vue?vue&type=template&id=1752b445&scoped=true&"
import script from "./MessageMenu.vue?vue&type=script&lang=js&"
export * from "./MessageMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessageMenu.vue?vue&type=style&index=0&id=1752b445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752b445",
  null
  
)

export default component.exports